var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('v-chip',{attrs:{"text":"","small":"","color":_vm.key[_vm.value].color},domProps:{"textContent":_vm._s(_vm.key[_vm.value].text)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }